export enum ClassifiedItemType {
	/**
	 * 미분류
	 */
   NOT_DEFINED = "NOT_DEFINED",

	/**
	 * 신규
	 */
   NEW = "NEW",
	
   /**
    * 예외
    */
   EXCEPTION = "EXCEPTION",
 
   /**
    * 기존
    */
   EXISTING = "EXISTING",

   /**
    * 제외
    */
   EXCLUDED = "EXCLUDED",

   /**
    * 예외고정
    */
   EXCEPTION_LOCK = "EXCEPTION_LOCK",

   /**
    * 기존고정
    */
   EXISTING_LOCK = "EXISTING_LOCK",
}

export const ClassifiedItemTypes = [
  {
    value: ClassifiedItemType[ClassifiedItemType.NOT_DEFINED],
    label: '미분류',
    status: 'basic',
  },
  {
    value: ClassifiedItemType[ClassifiedItemType.NEW],
    label: '신규',
    status: 'success',
  },
  {
    value: ClassifiedItemType[ClassifiedItemType.EXCEPTION],
    label: '예외',
    status: 'warning',
  },
  {
    value: ClassifiedItemType[ClassifiedItemType.EXISTING],
    label: '패턴',
    status: 'primary',
  },
  {
    value: ClassifiedItemType[ClassifiedItemType.EXCLUDED],
    label: '미사용',
    status: 'danger',
  },
  {
    value: ClassifiedItemType[ClassifiedItemType.EXCEPTION_LOCK],
    label: '제외',
    status: 'warning',
  },
  {
    value: ClassifiedItemType[ClassifiedItemType.EXISTING_LOCK],
    label: '기존',
    status: 'primary',
  },
];
